// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 29) return "static/js/8a60cff605dcc9b7b767.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"a836eaea2209d80b0c0a","150":"faa448ccbf7ef4bcdadf","151":"f1202a7c7c3217045d4e"}[chunkId] + ".chunk.js";
};